export function parseIqBoostConfigurationRecord<T extends object>(textValue: string | null | undefined, createDefault: () => T): T {
  if (!textValue) return createDefault();
  try {
    const stored: unknown = JSON.parse(textValue);
    return typeof stored === 'object' && stored !== null && !Array.isArray(stored) ? (stored as T) : createDefault();
  } catch {
    return createDefault();
  }
}
